export default __webpack_public_path__ + "0951619e5c05852b46f8873ea1893fe1.svg";